import React, { useEffect } from "react";
import Events from "../components/events/Events";
import { getAllEventsAction } from "../store/eventManagement/actions";
import { useDispatch, useSelector } from "react-redux";
import { getAllCategoriesAction } from "../store/category/actions";
import { getOrganisationsAction } from "../store/auth/authActions";

const LandingPage = () => {
  const { layout } = useSelector((state) => state);
  const dispatch = useDispatch();

  useEffect(() => {
    getAllEventsAction(
      `?isPublished=true${
        layout?.filterByCategory !== null
          ? `&category=${layout?.filterByCategory}`
          : ""
      }${
        layout?.filterByOrganisation !== null
          ? `&organization=${layout?.filterByOrganisation}`
          : ""
      }${
        layout?.filterBySearch !== null ? `&sk=${layout?.filterBySearch}` : ""
      }${layout?.filterByDate !== null ? `&${layout?.filterByDate}` : ""}`
    )(dispatch);
  }, [
    dispatch,
    layout?.filterByCategory,
    layout?.filterByOrganisation,
    layout?.filterBySearch,
    layout?.filterByDate,
  ]);

  useEffect(() => {
    getAllCategoriesAction("?")(dispatch);
    getOrganisationsAction()(dispatch);
  }, [dispatch]);

  return <Events />;
};

export default LandingPage;
